<template>
  <VDropdown
      v-if="actions.length > 1 || !showSingle"
      :disabled="isDisabled"
      :class="{disabled: isDisabled}"
      :placement="placement"
      @show="emit('open')"
      @hide="emit('close')"
  >
    <slot>
      <i class="actions-trigger icon-v-dots cursor-pointer" />
    </slot>

    <template #popper="{hide}">
      <ul class="dropdown-menu">
          <li v-for="action in list"
              :key="action.name"
          >
            <a class="dropdown-item"
               href="#"
               @click.prevent="onClick(action, hide)"
            >
              <i v-if="action.icon" :class="action.icon" />
              <span v-if="!action.ignoreCount && bulk" class="badge badge--default me-2">
                {{ action.data.length }}
              </span>
              {{ $te(action.title) ? $t(action.title) : action.title }}
            </a>
          </li>
      </ul>
    </template>
  </VDropdown>

  <div v-else
       @click.prevent="onClick(actions[0])"
  >
    <slot v-bind="{action: actions[0], act: onClick}">
      <i class="icon-v-dots cursor-pointer" />
    </slot>
  </div>
</template>
<script setup>
import {computed, ref} from "vue";
import {useAction} from "@/js/Plugins/Action.js";

const props = defineProps({
  actions: Array,
  items: Array,
  bulk: Boolean,
  showSingle: Boolean,
  disabled: Boolean,
  placement: {
    type: String,
    default: 'bottom'
  }
});
const emit = defineEmits(['action', 'success', 'error', 'complete', 'request', 'open', 'close']);
const callAction = useAction();
const loading = ref(false);
const list = computed(() => {
  const data = [...(props.actions || [])].map((action) => {
    action.data = !props.bulk ? 0 : ([...props.items] || [])
        .map(item => item.config?.bulk ? item.config.bulk[action.id] : undefined)
        .filter(v => typeof v !== 'undefined');
    return action;
  });

  if (!props.bulk) return data;
  return data.filter(a => a.data && a.data.length);
});
const isDisabled = computed(() => {
  return props.disabled || !list.value.length;
});

function onClick(action, hide) {
  loading.value = true;
  callAction(action, () => {
    if (action.request) {
      emit('request');
    }
    emit('action', action);
  }).then(() => {
    emit('success');
  }).catch((error) => {
    emit('error', error);
  }).finally(() => {
    emit('complete');
    loading.value = false;
  });

  if (typeof hide !== 'function') return;
  hide();
}
</script>